import { render } from "./leads-details.vue?vue&type=template&id=b35d30a6&scoped=true"
import script from "./leads-details.vue?vue&type=script&lang=js"
export * from "./leads-details.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./leads-details.vue?vue&type=style&index=1&id=b35d30a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35d30a6"]])

export default __exports__